(function () {
  function initSection(sectionEl) {
    if (!sectionEl) return;

    var track = sectionEl.querySelector('.oddit-section-featured-reviews-carousel__track');
    var cards = sectionEl.querySelectorAll('.oddit-section-featured-reviews-carousel__card');
    var prevBtn = sectionEl.querySelector('.oddit-section-featured-reviews-carousel__arrow--prev');
    var nextBtn = sectionEl.querySelector('.oddit-section-featured-reviews-carousel__arrow--next');
    var dots = sectionEl.querySelectorAll('.oddit-section-featured-reviews-carousel__dot');
    var trackWrapper = sectionEl.querySelector('.oddit-section-featured-reviews-carousel__track-wrapper');

    if (!track || cards.length === 0) return;

    var currentIndex = 0;
    var totalSlides = cards.length;
    var startX = 0;
    var currentX = 0;
    var isDragging = false;
    var autoplayTimer = null;

    function getCardWidth() {
      var card = cards[0];
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.gap) || 0;
      return card.offsetWidth + gap;
    }

    function getVisibleWrapperWidth() {
      var w = trackWrapper.offsetWidth;
      var parent = trackWrapper.parentElement;
      if (!parent) return w;
      var cs = window.getComputedStyle(parent);
      var pl = parseFloat(cs.paddingLeft) || 0;
      var pr = parseFloat(cs.paddingRight) || 0;
      var inner = parent.clientWidth - pl - pr;
      if (inner > 0 && w > inner) return inner;
      return w;
    }

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentIndex = index;

      var cardWidth = getCardWidth();
      var offset = cardWidth * currentIndex;

      // On desktop, the track has symmetric horizontal padding that centers
      // every card in the viewport, so the last-card-centered offset is simply
      // (N - 1) * cardWidth. Relying on scrollWidth here is unreliable because
      // Chromium/WebKit omit padding-inline-end from a flex container's
      // scrollWidth when its content overflows.
      // On mobile, the track is left-aligned (no centering padding), so we
      // clamp to trackWidth - wrapperWidth to keep the last card flush right.
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var maxOffset;
      if (isDesktop) {
        maxOffset = cardWidth * (totalSlides - 1);
      } else {
        maxOffset = track.scrollWidth - getVisibleWrapperWidth();
      }
      if (maxOffset < 0) maxOffset = 0;
      offset = Math.max(0, Math.min(offset, maxOffset));

      track.style.transform = 'translateX(-' + offset + 'px)';

      // Update dots
      for (var i = 0; i < dots.length; i++) {
        if (i === currentIndex) {
          dots[i].classList.add('oddit-section-featured-reviews-carousel__dot--active');
          dots[i].setAttribute('aria-selected', 'true');
        } else {
          dots[i].classList.remove('oddit-section-featured-reviews-carousel__dot--active');
          dots[i].setAttribute('aria-selected', 'false');
        }
      }
    }

    // Arrow navigation
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToSlide(currentIndex + 1);
      });
    }

    // Dot navigation
    for (var d = 0; d < dots.length; d++) {
      (function (i) {
        dots[i].addEventListener('click', function () {
          goToSlide(i);
        });
      })(d);
    }

    // Touch/swipe support
    trackWrapper.addEventListener('touchstart', function (e) {
      isDragging = true;
      startX = e.touches[0].clientX;
      track.style.transition = 'none';
    }, { passive: true });

    trackWrapper.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      currentX = e.touches[0].clientX;
    }, { passive: true });

    trackWrapper.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.4s ease';
      var diff = startX - currentX;
      var threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          goToSlide(currentIndex + 1);
        } else {
          goToSlide(currentIndex - 1);
        }
      } else {
        goToSlide(currentIndex);
      }
    });

    // Mouse drag support
    function onMouseMove(e) {
      if (!isDragging) return;
      currentX = e.clientX;
    }

    function onMouseUp() {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.4s ease';
      trackWrapper.style.cursor = '';
      var diff = startX - currentX;
      var threshold = 50;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          goToSlide(currentIndex + 1);
        } else {
          goToSlide(currentIndex - 1);
        }
      } else {
        goToSlide(currentIndex);
      }
    }

    trackWrapper.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.clientX;
      currentX = e.clientX;
      track.style.transition = 'none';
      trackWrapper.style.cursor = 'grabbing';
      e.preventDefault();
    });

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);

    // Keyboard navigation
    sectionEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        goToSlide(currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        goToSlide(currentIndex + 1);
      }
    });

    // Auto-play
    var rawSpeed = parseInt(sectionEl.getAttribute('data-autoplay-speed'), 10);
    var autoplaySpeed = (!isNaN(rawSpeed) && rawSpeed > 0) ? rawSpeed : 0;

    function startAutoplay() {
      stopAutoplay();
      if (autoplaySpeed <= 0) return;
      autoplayTimer = setInterval(function () {
        goToSlide(currentIndex + 1);
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // Pause on hover, resume on leave
    sectionEl.addEventListener('mouseenter', stopAutoplay);
    sectionEl.addEventListener('mouseleave', startAutoplay);

    // Pause during touch, resume after
    trackWrapper.addEventListener('touchstart', function () {
      stopAutoplay();
    }, { passive: true });
    trackWrapper.addEventListener('touchend', function () {
      startAutoplay();
    });

    // Recalculate on resize
    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        goToSlide(currentIndex);
      }, 150);
    }
    window.addEventListener('resize', onResize);

    // Cleanup function for theme editor
    function destroy() {
      stopAutoplay();
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      window.removeEventListener('resize', onResize);
    }

    // Store destroy reference on the element
    sectionEl._odditCarouselDestroy = destroy;

    // Initialize
    goToSlide(0);
    startAutoplay();
  }

  // Initialize all instances on the page
  function initAll() {
    var sections = document.querySelectorAll('.oddit-section-featured-reviews-carousel');
    for (var i = 0; i < sections.length; i++) {
      if (!sections[i]._odditCarouselDestroy) {
        initSection(sections[i]);
      }
    }
  }

  initAll();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var container = e.target;
    var sectionEl = container.querySelector('.oddit-section-featured-reviews-carousel');
    if (sectionEl) {
      if (typeof sectionEl._odditCarouselDestroy === 'function') {
        sectionEl._odditCarouselDestroy();
        delete sectionEl._odditCarouselDestroy;
      }
      initSection(sectionEl);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var container = e.target;
    var sectionEl = container.querySelector('.oddit-section-featured-reviews-carousel');
    if (sectionEl && typeof sectionEl._odditCarouselDestroy === 'function') {
      sectionEl._odditCarouselDestroy();
      delete sectionEl._odditCarouselDestroy;
    }
  });
})();